module.exports = __webpack_public_path__ + "static/media/IOST.5ebb0c0d.svg";